import DeleteOrganizations from './DeleteOrganizations'

export default DeleteOrganizations
